export type AttendeeProfileField =
  | number
  | `select_${number}`
  | 'full_name'
  | 'avatar'
  | 'verified'
  | 'preferred_language'
  | 'linkedIn'
  | 'twitter'
  | 'job_title'
  | 'department'
  | 'company_name'
  | 'industry'
  | 'phone_number';
export type AttendeeLocationField =
  | 'city'
  | 'state'
  | 'countryCode'
  | 'countryName'
  | 'lat'
  | 'lon'
  | 'zip'
  | 'timezone';
export type AttendeeStatsField =
  | 'total_registered'
  | 'total_viewed'
  | 'no_shows'
  | 'last_watch'
  | 'first_watch'
  | 'total_seconds';
export type AttendeeEventDataField =
  | 'created_date'
  | 'referrer'
  | 'utm_params'
  | 'num_questions'
  | 'num_comments'
  | 'num_reactions'
  | 'device_type'
  | 'browser'
  | 'total_seconds'
  | 'attended'
  | 'attended_phase'
  | 'source'
  | 'engagement_score'
  | 'associated_campaigns';

export type AttendeeFields = {
  profile?: AttendeeProfileField[];
  location?: AttendeeLocationField[];
  stats?: AttendeeStatsField[];
  event_data?: AttendeeEventDataField[];
};

// Default response shape when no fields are specified
export type AttendeeUserDefault = {
  bl_profile: number | null;
  email: string;
  full_name: string | null;
  job_title: string | null;
  department: string | null;
  company_name: string | null;
  industry: string | null;
  phone_number: string | null;
  avatar: string | null;
  city: string | null;
  state: string | null;
  countryCode: string | null;
  timezone: string | null;
  preferred_language: string | null;
  total_registered: number | null;
  total_viewed: number | null;
  no_shows: number | null;
  last_watch: string | null;
  first_watch: string | null;
  total_seconds: number | null;
  1: string | null;
  2: string | null;
};

// Dynamic response shape when specific fields are requested
export type AttendeeUserCustom = {
  bl_profile: number | null;
  email: string;
  [key: string]: unknown;
};

export type AttendeeUser = AttendeeUserDefault | AttendeeUserCustom;

export type AttendeesResponse<T = AttendeeUser> = {
  total: number;
  data: T[];
};

export type AttendeeSortDirection = 'asc' | 'desc';

export enum UserStatus {
  REGISTERED = 'registered',
  ATTENDED = 'attended',
  NO_SHOWS = 'no_shows',
}

export type RegistrationFilter = 'all' | 'registered' | 'invited' | 'added';

export type LoadAttendeesParams = {
  channel: number | null;
  eventUuid: string;
  page?: number;
  pageSize?: '10' | '25' | '50' | '100';
  passcodeListId?: number;
  search?: string;
  sort?: string;
  sortDirection?: AttendeeSortDirection;
  fields?: AttendeeFields;
  status?: UserStatus;
  registrationStatusFilter?: RegistrationFilter;
  signal?: AbortSignal;
};
